import { api } from "roboflex-thalamus-request-handler";

const BASE = "os2/ordem-servico";

const DIAS_UTEIS_FIM_PREVISTO = 7;

function toDateOnly(val) {
  if (val == null || val === "") return null;
  const s = String(val).trim();
  if (s.length >= 10) return s.slice(0, 10);
  return null;
}

/** Soma 7 dias úteis (seg–sex) após a data base, sem contar o próprio dia. */
export function calcularDtFimPrevisto7DiasUteis(dataIso) {
  const base = toDateOnly(dataIso);
  if (!base) return null;
  const [y, m, d] = base.split("-").map(Number);
  let date = new Date(y, m - 1, d);
  let restantes = DIAS_UTEIS_FIM_PREVISTO;
  while (restantes > 0) {
    date.setDate(date.getDate() + 1);
    const dow = date.getDay();
    if (dow !== 0 && dow !== 6) restantes -= 1;
  }
  const yy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

export async function listarClientesOsAssistencia() {
  const { data } = await api.get("cliente");
  return Array.isArray(data) ? data : [];
}

export async function listarPosVendasOsAssistencia() {
  const { data } = await api.get("/pos-venda/listar");
  if (Array.isArray(data)) return data;
  return data?.data ?? data?.cadastros ?? [];
}

export async function buscarProdutosOs2(q) {
  const { data } = await api.get("os2/produtos/buscar", {
    params: { q: q ?? "" },
  });
  return Array.isArray(data) ? data : [];
}

export async function criarAssistenciaEmAnalise(payload) {
  const produtos = Array.isArray(payload.produtos) ? payload.produtos : [];
  const body = {
    pos_venda_id:
      payload.pos_venda_id != null ? Number(payload.pos_venda_id) : null,
    cliente_id:
      payload.cliente_id != null ? Number(payload.cliente_id) : null,
    dt_prevista_recebimento_material: toDateOnly(
      payload.dt_prevista_recebimento_material ?? payload.dtPrevistaRecebimentoMaterial,
    ),
    observacoes:
      payload.observacoes != null ? String(payload.observacoes) : null,
    nf_entrada:
      payload.nf_entrada != null || payload.nfEntrada != null
        ? String(payload.nf_entrada ?? payload.nfEntrada).trim() || null
        : null,
    produtos,
  };
  const { data } = await api.post(`${BASE}/assistencia-em-analise`, body);
  return data;
}

function normalizarOsResumo(raw) {
  if (!raw || typeof raw !== "object") return raw;
  const produtos = Array.isArray(raw.produtos) ? raw.produtos : [];
  const cli = raw.cliente;
  return {
    id: raw.id,
    codigo: raw.codigo,
    status: raw.status,
    dt_fim_previsto: raw.dt_fim_previsto,
    cliente_nome: cli?.nome ?? cli?.razao_social ?? "",
    qtd_produtos: produtos.length,
  };
}

export async function listarOsAssistenciaPorPosVenda(posVendaId) {
  const { data } = await api.get(BASE, {
    params: {
      pos_venda_id: Number(posVendaId),
      per_page: 100,
      order_by: "id",
      order_dir: "desc",
    },
  });
  const lista = Array.isArray(data) ? data : data?.data ?? [];
  return Array.isArray(lista) ? lista.map(normalizarOsResumo) : [];
}

export async function obterOsAssistenciaDetalhe(osId) {
  const { data } = await api.get(`${BASE}/${Number(osId)}`);
  return data;
}

export async function atualizarCabecalhoOsAssistenciaPosVenda(osId, payload) {
  const body = {
    nf_entrada: String(payload.nf_entrada ?? "").trim(),
  };
  if (payload.dt_prevista_recebimento_material != null) {
    body.dt_prevista_recebimento_material = toDateOnly(
      payload.dt_prevista_recebimento_material,
    );
  }
  const { data } = await api.patch(
    `${BASE}/${Number(osId)}/assistencia/cabecalho-pos-venda`,
    body,
  );
  return data;
}

const URL_BASE_DEMANDAS =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8081"
    : "https://demandas.thalamus.ind.br";

export function urlEditarOsAssistenciaDemandas(osId) {
  return `${URL_BASE_DEMANDAS}/#/ordem-servico/${osId}/editar-assistencia`;
}
